import { isPlatformBrowser } from '@angular/common';
import { Component, DoCheck, ElementRef, HostListener, Inject, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { DropdownOption } from '@maced/angular-components/lib/dropdown/dropdown.model';
import { AriaLabels } from '@maced/angular-components/lib/error-state/error-state-interface';
import { MultiSelectOption } from '@maced/angular-components/lib/multi-select/multi-select.model';
import { Placement } from '@popperjs/core';
import { Subscription, delay, first, of } from 'rxjs';

@Component({
  selector: 'app-filter-toolbar',
  templateUrl: './filter-toolbar.component.html'
})
export class FilterToolbarComponent implements OnInit, DoCheck, OnDestroy {
  title3 = 'No results have been found';
  id3 = 'errorContainer3';
  imageUrl3 = '/assets/default/images/error_blue/No-search-results.svg';
  ariaLabels: AriaLabels = {
    imageAltText: 'banner-image'
  }
  hasErrorState = false;
  hasCloseButton: boolean = false;
  hasBackdrop: boolean = true;
  hasCaret: boolean = false;
  selectedPlacement: Placement = 'bottom-end';
  hasIcon = true;
  hasExternalButton = true;
  hasSearchOption = true;
  hasSorting = true;
  hasFilter = true;
  hasSortBy = true;
  hasVeiwBy = true;
  clearData = '' as string;
  options1: DropdownOption[] = [
    {
      id: 'option11',
      name: 'option11',
      label: 'Newest First',
      url: '/filter-sorting'
    },
    {
      id: 'option12',
      name: 'option12',
      label: 'Oldest First',
      url: '/filter-sorting'
    },
    {
      id: 'option13',
      name: 'option13',
      label: 'Students to grade: High-Low',
      url: '/filter-sorting'
    },
    {
      id: 'option14',
      name: 'option14',
      label: 'Students to grade: Low-High',
      url: '/filter-sorting'
    }
  ];
  options2: DropdownOption[] = [
    {
      id: 'option1',
      name: 'option1',
      label: 'Last Week',
      url: '/filter-sorting'
    },
    {
      id: 'option2',
      name: 'option2',
      label: 'Last Month',
      url: '/filter-sorting'
    },
    {
      id: 'option3',
      name: 'option3',
      label: 'Last 3 Months',
      url: '/filter-sorting'
    },
    {
      id: 'option4',
      name: 'option4',
      label: 'All time',
      url: '/filter-sorting'
    }
  ];
  selectedOptions1!: any;
  selectedOptions2!: any;

  options10: DropdownOption[] = [
    {
      id: 'grammar',
      name: 'grammar',
      label: 'Grammar',
      isTitle: true
    },
    {
      id: 'GrammarPreparation',
      name: 'GrammarPreparation',
      label: 'Grammar Preparation: Present perftect simple and past simple ',
      url: '/filter-sorting'
    },
    {
      id: 'vocabularyPreparation',
      name: 'vocabularyPreparation',
      label: 'vocabulary Preparation: Collections: making big decisions',
      url: '/filter-sorting'
    },
    {
      id: 'PronounciationPreparation',
      name: 'PronounciationPreparation',
      label: 'Pronounciation Preparation: s and ve',
      url: '/filter-sorting'
    },
    {
      id: 'reading',
      name: 'reading',
      label: 'Reading',
      isTitle: true
    }, {
      id: 'GrammarReading',
      name: 'GrammarReading',
      label: 'Grammar Preparation: Present perftect simple and past simple ',
      url: '/filter-sorting'
    },
    {
      id: 'vocabularyReading',
      name: 'vocabularyReading',
      label: 'vocabulary Preparation: Collections: making big decisions',
      url: '/filter-sorting'
    },
    {
      id: 'PronounciationReading',
      name: 'PronounciationReading',
      label: 'Pronounciation Preparation: s and ve',
      url: '/filter-sorting'
    }
  ];
  selectedOptions10!: any;
  buttonList = [
    {
      id: 'clearAll',
      name: 'clearAll',
      label: 'Clear filters',
      url: '/filter-sorting',
      hasClearButton: true,
      disabled: false,
      queryParams: { 'ButtonId': 'clear' }
    },
    {
      id: 'apply',
      name: 'apply',
      label: 'Apply filters',
      url: '/filter-sorting',
      hasApplyButton: true,
      disabled: false,
      queryParams: { 'ButtonId': 'apply' }
    }];
  options11: DropdownOption[] = [
    {
      id: '21Lession',
      name: '21Lession',
      label: '2.1 Lession important decisions ',
      url: '/filter-sorting'
    },
    {
      id: '22Lession',
      name: '22Lession',
      label: '2.2 Lession you can do it!',
      url: '/filter-sorting'
    },
    {
      id: '23Lession',
      name: '23Lession',
      label: '2.3 Lession Speaking',
      url: '/filter-sorting'
    }
  ];
  selectedOptions11!: any;
  formElement!: FormGroup;
  selectedList: any[] = [];
  screenSize: number = 1024;
  minimumScreenResolution = 767;
  isBrowser = true;
  sortByList = [{
    label: 'Oldest First',
    checked: 'Oldest First'
  }, {
    label: 'Newest First',
    checked: ''
  }, {
    label: 'Students to grade: High-Low',
    checked: ''
  }, {
    label: 'Students to grade: Low-High',
    checked: ''
  }];
  viewByList = [{
    label: 'Last Week',
    checked: ''
  }, {
    label: 'Last Month',
    checked: ''
  }, {
    label: 'Last 3Months',
    checked: ''
  }, {
    label: 'All time',
    checked: 'All time'
  }];
  selectedOptionList: MultiSelectOption[] = [];
  ariaExpanded = false;
  options: MultiSelectOption[] = [
    {
      id: 'level1',
      name: 'level1',
      label: 'Speak your mind - Level 1',
      disabled: false,
      isTitle: true
    },
    {
      id: 'assessment',
      name: 'assessment',
      label: 'Assessment',
      disabled: false,
      checked: false,
      closeButtonArialabel: 'Close'
    },
    {
      id: 'homework',
      name: 'homework',
      label: 'Homework',
      disabled: false,
      checked: false,
      closeButtonArialabel: 'Close'
    },
    {
      id: 'preparationAndPractice',
      name: 'preparationAndPractice',
      label: 'Preparation and Practice',
      disabled: false,
      checked: false,
      closeButtonArialabel: 'Close'
    },
    {
      id: 'mainCourseBook',
      name: 'mainCourseBook',
      label: 'Main Course Book',
      disabled: false,
      checked: false,
      closeButtonArialabel: 'Close'
    },
    {
      id: 'Beginner',
      name: 'Beginner',
      label: 'Language Hub - Beginner',
      disabled: false,
      isTitle: true
    },
    {
      id: 'assessmentLH',
      name: 'assessmentLH',
      label: 'Assessment',
      disabled: false,
      checked: false,
      closeButtonArialabel: 'Close'
    },
    {
      id: 'homeworkLH',
      name: 'homeworkLH',
      label: 'Homework',
      disabled: false,
      checked: false,
      closeButtonArialabel: 'Close'
    },
    {
      id: 'practiceQuiz',
      name: 'practiceQuiz',
      label: 'Practice Quiz',
      disabled: false,
      checked: false,
      closeButtonArialabel: 'Close'
    },
    {
      id: 'studentsBook',
      name: 'studentsBook',
      label: 'Students Book',
      disabled: false,
      checked: false,
      closeButtonArialabel: 'Close'
    },
  ];

  private queryParamSubscription!: Subscription;
  searchInputLabelEnglish = { submitlabel: 'Submit', close: 'Clear', search: 'search' };
  mobileview!: boolean;
  currentUrl: string;
  constructor(private formBuilder: FormBuilder, private route: ActivatedRoute,
    private router: Router, @Inject(PLATFORM_ID) public platformId: object, private _elementRef: ElementRef,) {
      if (isPlatformBrowser(this.platformId)) {
        this.isBrowser = true;
        this.screenSize = window.innerWidth;      
      } else{
        this.isBrowser = false;
      }
      this.currentUrl = this.router.url.split('?')[0];
     }
  @HostListener('window:resize', ['$event'])
  onResize(event:any) {
    this.screenSize = event.target.innerWidth;
    if(this.isBrowser && this.screenSize <= this.minimumScreenResolution){
      this.mobileFilteredList();
    }else{
      this.desktopFilteredList();
    }
  }
  ngOnInit(): void {
    this.ariaExpanded = !this.ariaExpanded;
    this.formElement = this.formBuilder.group({
      inputVal: [''],
    });   
    if(this.isMobileWidth()){
      this.sortByList.forEach((obj) => {
        if (obj.checked !== '') {
          this.selectedList.push(obj)
        }
      });
      this.viewByList.forEach((obj) => {
        if (obj.checked !== '') {
          this.selectedList.push(obj)
        }
      });
    } 
    
    this.queryParamSubscription = this.route.queryParams.subscribe(param => {
      if (param.input !== '') {
        this.hasErrorState = false;
      }
      else if (param.input === '') {
        this.hasErrorState = true;
      }
      let snapshot = this.route.snapshot;
      let queryParams = { ...snapshot.queryParams };
      if (param['chipId'] && param['isDelete']) {
        delete queryParams[param['chipId']];
        delete queryParams['chipId'];
        delete queryParams['isDelete'];
        this.router.navigate(['/filter-sorting'], { queryParams: queryParams });
      }

      this.options = this.options.map((obj: MultiSelectOption) => {
        if (param[obj.id] ) {
          this.selectedOptionList.push(obj);
          obj.checked = true;
        } else {
          obj.checked = false;
        }
        return obj;
      });
      if (param.dropdownId && param.dropdownId === 'dropdownId5') {
        this.options1.forEach((obj) => {
          if (obj.id === param.selectedDropdownOptionId) {
            obj.active = true;
            this.selectedOptions1 = obj;
            this.filterMobileView();
          } else {
            obj.active = false;
          }
        });
      }
      if (param.dropdownId && param.dropdownId === 'dropdownId2') {
        this.options2.forEach((obj) => {
          if (obj.id === param.selectedDropdownOptionId) {
            obj.active = true;
            this.selectedOptions2 = obj;
            this.filterMobileView();
          } else {
            obj.active = false;
          }
        });
      }
      if (param.dropdownId && (param.dropdownId === 'dropdownId10' || param.dropdownId === 'dropdownId12')) {
        this.options10.forEach((obj) => {
          if (obj.id === param.selectedDropdownOptionId) {
            obj.active = true;
            this.selectedOptions10 = obj;
          } else {
            obj.active = false;
          }
        });
      }
      if (param.dropdownId && (param.dropdownId === 'dropdownId11' || param.dropdownId === 'dropdownId13')) {
        this.options11.forEach((obj) => {
          if (obj.id === param.selectedDropdownOptionId) {
            obj.active = true;
            this.selectedOptions11 = obj;
          } else {
            obj.active = false;
          }
        });
      }
      if (param.ButtonId && param.ButtonId === 'clear') {
        this.selectedList = [];
        this.router.navigate([], {
          queryParams: {
            'dropdownId': null,
            'selectedDropdownOptionId': null,
            'ButtonId': null
          },
          queryParamsHandling: 'merge'
        });
        this.options10.forEach((obj) => {
          obj.active = false;
        });
        this.selectedOptions10 = { label: 'Please select' }
        this.options11.forEach((obj) => {
          obj.active = false;
        });
        this.selectedOptions11 = { label: 'Please select' }
        this.sortByList.forEach((obj) => {
          obj.checked = ''
        });
        this.viewByList.forEach((obj) => {
          obj.checked = ''
        });
        this.selectedOptionList = [];
      }
      if (param.ButtonId && param.ButtonId === 'apply') {
        if(this.isBrowser && this.screenSize <= this.minimumScreenResolution){
          this.mobileFilteredList();
        }else{
          this.desktopFilteredList();
        }  
        this.router.navigate([], {
          queryParams: {
            'ButtonId': null
          },
          queryParamsHandling: 'merge'
        });
        this.clearData = '';
      }
      this.buttonList.forEach((obj:any)=>{
        if((this.selectedOptions11 && this.selectedOptions11.id) || (this.selectedOptions10 && this.selectedOptions10.id) || (this.selectedOptionList && this.selectedOptionList.length > 0) || (this.selectedList.length > 0)){
          obj.disabled = false;
          this.clearData = '';
        }else{
          obj.disabled = true;
          this.clearData = 'All data cleared';
        }
      });
    });
  }

  buttonFocus(){
    if(!document.getElementById('floatingpanel1')?.hasAttribute('data-show')){
      document.getElementById('buttonId1')?.focus();
    }
  }

  inputValue(event:any){
    this.route.queryParams.subscribe(param => {
      if (param.ButtonId && (param.ButtonId === 'clear' || param.ButtonId === 'apply')) {
        event.target.value = '';
      }
    });
  }
  onClickOption(selectedOptionList: MultiSelectOption[]) {
    this.selectedOptionList = selectedOptionList;
    this.queryParamSubscription = this.route.queryParams.subscribe(param => {
      if(param.isDelete || (param.ButtonId && param.ButtonId === 'apply')){
        if(this.isBrowser && this.screenSize <= this.minimumScreenResolution){
          this.mobileFilteredList();
        }else{
          this.desktopFilteredList();
        }       
      }
    });    
     this.buttonList.forEach((obj:any)=>{
      if((this.selectedOptions11 && this.selectedOptions11.id) || (this.selectedOptions10 && this.selectedOptions10.id) || (this.selectedList.length > 0) || (this.selectedOptionList && this.selectedOptionList.length > 0)){
        obj.disabled = false;
      }else{
        obj.disabled = true;
      }
    });   
  }
  desktopFilteredList(){
    this.selectedList = []; 
    if(this.selectedOptionList.length > 0){
      this.selectedList.push(this.selectedOptionList);
    } else{
      this.selectedList = [];
    }
    this.options11.forEach((obj) => {
      if (obj.active === true) {
        this.selectedList.push(obj)
      }
    });
    this.options10.forEach((obj) => {
      if (obj.active === true) {
        this.selectedList.push(obj)
      }
    });
  }
  mobileFilteredList(){
    this.selectedList = []; 
    this.desktopFilteredList();
      this.sortByList.forEach((obj) => {
        if (obj.checked !== '') {
          this.selectedList.push(obj)
        }
      });
      this.viewByList.forEach((obj) => {
        if (obj.checked !== '') {
          this.selectedList.push(obj)
        }
      });
  }

  isMobileWidth() {
    if (isPlatformBrowser(this.platformId)) {
      return window?.innerWidth < 1023
    }
    else {
      return false;
    }
  }
  ngDoCheck(){
    if(this.isBrowser){
      if(document.getElementById('floatingpanel1')?.hasAttribute('data-show')){
        this.ariaExpanded = true;
      }else{
        this.ariaExpanded = false;       
      }
      document.getElementById('floatingpanel1')?.removeAttribute('role');
    }
  }

  filterMobileView(){
    this.options1.forEach((dropdownObj) => {
    this.sortByList.forEach((obj) => {
      if(dropdownObj.label === obj.label){
        if(dropdownObj.active === true){
          obj.checked = dropdownObj.label;
        } else {
          obj.checked = '';
        }
      }     
    });
  });
    this.options2.forEach((dropdownObj) => {
      this.viewByList.forEach((obj) => {
        if(dropdownObj.label === obj.label){
          if(dropdownObj.active === true){
            obj.checked = dropdownObj.label;
          } else {
            obj.checked = '';
          }
        } 
      }); 
    })
  }

  singleCheckbox(item: any, value: string, event: any): void {
    const valueType = event.target.type;
    if (value === 'viewBy') {
      this.viewByList.forEach((obj: any) => {
        if (valueType == 'radio' && item.label === obj.label) {
          obj.checked = event.target.value;
        } else {
          obj.checked = '';
        }
      });
    }
    if (value === 'sortBy') {
      this.sortByList.forEach((obj: any) => {
        if (valueType == 'radio' && item.label === obj.label) {
          obj.checked = event.target.value;
        } else {
          obj.checked = '';
        }
      });
    }
  }

  buttonLabelText(){
    let labelText;
    if(this.selectedList.length > 0){
      labelText = 'Filters'+' ('+ this.selectedList.length +')';
    } else{
      labelText = 'Filters';
    }
    return labelText;
  }

  tabIndexRemove(){
    of('Observable To Update HTML').pipe(first(),delay(0)).subscribe(() => {
      if (this._elementRef.nativeElement.getElementsByTagName('maced-button')) {
        Array.from(this._elementRef.nativeElement.getElementsByTagName('maced-button')).forEach(element =>{
          (element as HTMLElement).removeAttribute('tabIndex');
        })
      }
    });
  }

  ngOnDestroy(): void {
    if (this.queryParamSubscription) {
      this.queryParamSubscription.unsubscribe();
    }    
  }
}
